import { connect } from 'react-redux';
import { ProductPreviewsComponent } from './product-previews';
import { productPreviewsSelector } from './connect/product-previews.selector';
import productPreviewsDispatcher from './connect/product-previews.dispatcher';
export const ProductPreviews = connect(productPreviewsSelector, productPreviewsDispatcher)(ProductPreviewsComponent);